import { library, dom } from '@fortawesome/fontawesome-svg-core';

import { faWindows, faApple } from '@fortawesome/free-brands-svg-icons';
import {
	faBars,
	faSignOut,
	faPlus,
	faArrowLeft,
	faArrowRight,
	faSearch,
	faCalendarAlt,
	faClone,
	faEllipsisH,
	faCheckCircle,
	faExclamationCircle,
	faSpinner,
	faCommentAltDots,
	faLongArrowRight,
	faTrashAlt,
	faPrint,
	faFileInvoice,
	faAngleLeft,
	faAngleRight,
	faCopy,
	faUpload,
	faHistory,
	faComment,
	faEdit
} from '@fortawesome/pro-regular-svg-icons';

import { faTimes } from '@fortawesome/pro-light-svg-icons';

import { faCircleCheck, faCircleXmark, faGear, faEnvelope, faCircle } from '@fortawesome/pro-solid-svg-icons';

library.add(
	faBars,
	faSignOut,
	faPlus,
	faArrowLeft,
	faArrowRight,
	faSearch,
	faCalendarAlt,
	faClone,
	faTimes,
	faEllipsisH,
	faCheckCircle,
	faSpinner,
	faCommentAltDots,
	faLongArrowRight,
	faTrashAlt,
	faPrint,
	faFileInvoice,
	faAngleLeft,
	faAngleRight,
	faCopy,
	faWindows,
	faApple,
	faUpload,
	faHistory,
	faComment,
	faExclamationCircle,
	faCircleCheck,
	faCircleXmark,
	faGear,
	faEnvelope,
	faEdit,
	faCircle
);

dom.watch();
